const Press = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Press</h1>
      <p>Updates, announcements and company highlights coming soon.</p>
    </div>
  );
};

export default Press;
